{
  "Fremdsystem": "KDM",
  "Index1-2": "PPE/COP",
  "Index1-3": "PPE/COP",
  "layouts.page.title": "Grundbuch- und Vermessungsamt Basel-Stadt",
  "layouts.page.titleNavigation": "Navigation"
}
